import { render, staticRenderFns } from "./manage-view.html?vue&type=template&id=72765eb2&scoped=true&external"
import script from "./manage-view.js?vue&type=script&lang=js&external"
export * from "./manage-view.js?vue&type=script&lang=js&external"
import style0 from "./manage-view.scss?vue&type=style&index=0&id=72765eb2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72765eb2",
  null
  
)

export default component.exports